export const ValidationPattern = {
  persianName: /^(?=.*[\u0600-\u06FF])[ \u0600-\u06FF]+$/,
  englishName: /^(?=.*[a-zA-Z])[ a-zA-Z]+$/,
  number: /^[0-9]+$/,
  userName: '[a-zA-z*&%$#@!%()-_+]{6,}',
  //  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/,
  password: /^[a-zA-z0-9_@#$%&/s]{6,16}$/,
  email:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^\+?[0-9]{1,3}(?:[-.\s]){0,2}[0-9]{1,14}$/,
  code: /^[a-zA-Z1-9#-_]+$/,
  url: /^(https?:\/\/)?([\da-z\.-]+\.[a-z\.]{2,6}|[\d\.]+)([\/:?=&#]{1}[\da-z\.-]+)*[\/\?]?$/gim,
  age: /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi,
  iranianNationalCode: /^d{10}$/,
  string: /^(?=.*[a-zA-Zآ-ی])[a-zA-Zآ-ی\s]+$/,
  text: /^[\u0600-\u06FF\sa-zA-Z0-9&._$#-]+$/,
  date: /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/,
  any: /^[\s\S]*$/,
  otpInput: /^((09|\+989)[0-9]{9}|[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4})$/,
  intNumber: new RegExp(/^\d+$/),
  positiveNumber: /^[1-9][0-9]*$/,
  flightNumber: /^[a-zA-Z1-9-_/\s]+$/,
  cardNo: /^\d{16}$/,
  monthDays_28: /^(0?[1-9]|1\d|2[0-8])$/,
  monthDays_29: /^(0?[1-9]|1\d|2[0-9])$/,
  monthDays_30: /^(0?[1-9]|[12][0-9]|30)$/,
  monthDays_31: /^(0?[1-9]|[12][0-9]|3[01])$/,
  year: /^\d{4}$/,
  positiveFloat: new RegExp('^[0-9]+(.[0-9]+)?$'),
  passportNumber: /^(?=[A-Za-z0-9\s\.-]{8,20}$)[A-Za-z0-9\s\.-]+$/,
};
